<script setup lang="ts">
import { toRef } from 'vue';
import type { PulseData } from '@/types/DataTypes';
import PulseTimeAllocationDisplay from './PulseTimeAllocationDisplay.vue';
import { useUserAllocationStats } from '@/composables/usePulseStats';

interface Props {
  pulses: PulseData;
}

const props = defineProps<Props>();

// Convert props to reactive reference for the composable
const pulsesRef = toRef(props, 'pulses');

// Use the centralized user allocation calculation logic
const { stats: weekStats } = useUserAllocationStats(pulsesRef);
</script>

<template>
  <div v-if="Object.keys(weekStats.allocation).length > 0" class="flex items-center">
    <PulseTimeAllocationDisplay
        class="w-full"
        :time-allocation="weekStats.allocation" :show-unallocated="true" :show-legend="true" />
  </div>
</template>
